var React = require('react');

function CaretDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.5 3 4 5.5 1.5 3","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CaretDownInline.defaultProps = {"width":"8","height":"8","fill":"none"};

module.exports = CaretDownInline;

CaretDownInline.default = CaretDownInline;
